import { h, Fragment } from "preact";

export default function ProductOptionPill({
  optionValue,
  optionName,
  disabled,
  updateOptionValue,
  selected,
}) {
  return (
    <label className="product-options__pill-wrapper">
      <input
        type="radio"
        name={optionName}
        value={optionValue.name}
        className="product-options__pill-input"
        onChange={(e) => updateOptionValue(e.target.value)}
        checked={selected}
      />
      <div className="product-options__pill">
        <div
          className={`product-options__pill-inner ${disabled ? "product-options__pill-inner--disabled" : ""}`}
        >
          <span>{optionValue.name}</span>
          {disabled && (
            <div className="product-options__pill-disabled-slash"></div>
          )}
        </div>
      </div>
    </label>
  );
}
